var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2071 10.293C10.3946 10.4805 10.4999 10.7348 10.4999 11C10.4999 11.2652 10.3946 11.5195 10.2071 11.707L6.20708 15.707C6.01955 15.8945 5.76525 15.9998 5.50008 15.9998C5.23492 15.9998 4.98061 15.8945 4.79308 15.707L0.793081 11.707C0.697571 11.6148 0.621389 11.5044 0.56898 11.3824C0.516571 11.2604 0.488985 11.1292 0.487831 10.9964C0.486677 10.8636 0.511978 10.7319 0.562259 10.609C0.61254 10.4861 0.686793 10.3745 0.780686 10.2806C0.874579 10.1867 0.986231 10.1125 1.10913 10.0622C1.23202 10.0119 1.3637 9.9866 1.49648 9.98775C1.62926 9.9889 1.76048 10.0165 1.88249 10.0689C2.00449 10.1213 2.11483 10.1975 2.20708 10.293L4.50008 12.586V1C4.50008 0.734784 4.60544 0.48043 4.79297 0.292893C4.98051 0.105357 5.23486 0 5.50008 0C5.7653 0 6.01965 0.105357 6.20719 0.292893C6.39472 0.48043 6.50008 0.734784 6.50008 1V12.586L8.79308 10.293C8.98061 10.1055 9.23492 10.0002 9.50008 10.0002C9.76525 10.0002 10.0196 10.1055 10.2071 10.293Z",
    fill: "current-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/arrow-down2.a0e7a665.svg";
export { ForwardRef as ReactComponent };